import algoliasearch from 'algoliasearch/lite'

export const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_ID,
  process.env.GATSBY_ALGOLIA_KEY
)

export const algoliaIndex = algoliaClient.initIndex(
  process.env.GATSBY_ALGOLIA_INDEX_NAME
)

export const algoliaIndexBrands = algoliaClient.initIndex(
  process.env.GATSBY_ALGOLIA_BRANDS_INDEX_NAME
)
